module.exports = __webpack_public_path__ + "static/media/PurpleSword.75471b58.png";